import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [CommonModule, TranslateModule],  // 👈 Import obbligatorio per *ngIf
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent {
  @Input() visible = false;
  @Input() title = 'Default Title';
  @Input() message = 'Default Message';
  @Output() closed = new EventEmitter<void>();

  close() {
    this.visible = false;
    this.closed.emit();
  }
}
